import { isBackspace, isDelete, isEscape, isNumeric, isPaste, isTab } from '@colescba/ui'

const F_KEYS = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12']

const isFKey = key => F_KEYS.includes(key)

const isEnter = key => key === 'Enter'

const useOnlyNumbers = event => {
  const key = event.key
  const isAllowedKey = [
    isEscape(key),
    isBackspace(key),
    isDelete(key),
    isTab(key),
    isPaste(key),
    isNumeric(key),
    isEnter(key),
    isFKey(key),
    event.ctrlKey,
    event.altKey,
    event.shiftKey,
  ].some(Boolean)
  return isAllowedKey || event.preventDefault()
}

export const useInput = () => ({
  methods: {
    useOnlyNumbers,
  },})
